import { IsNotEmpty, IsNumber, IsDefined, Validate, Equals, IsEmail } from 'class-validator';
import { computed } from 'mobx';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';
import { UserDynamicPropertyValidation } from 'src/core/customValidator/userDynamicPropertyValidator';

export class UserDataService extends DataService<typeof Model.Core.Logic.ViewModels.Security.UserItem, Model.Core.Logic.ViewModels.Security.UserItem, UserItem> {
	protected map(entity: Model.Core.Logic.ViewModels.Security.UserItem): UserItem {
		return new UserItemModel(entity);
	}

	static make(context?: any): UserDataService {
		return new UserDataService(context, ctx => ctx.Users);
	}

	add(defaultLanguage: string): Promise<UserItem> {
		const entity = new Model.Core.Logic.ViewModels.Security.UserItem();
		(entity as any).dynamicProperties = {
			language: defaultLanguage
		};
		entity.isRole = false;

		return this.create(() => entity);
	}
}

export class UserItemModel extends EntityModel<Model.Core.Logic.ViewModels.Security.UserItem, UserItem> implements UserItem {
	@property<UserItemModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<UserItemModel>(o => o.entity.userName, (o, value) => o.entity.userName = value)
	@IsDefined({
		message: 'username is empty'
	})
	public userName: string;

	@property<UserItemModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	@IsDefined({
		message: 'display name is empty'
	})
	public displayName: string;

	@property<UserItemModel>(o => o.entity.notificationEmail, (o, value) => o.entity.notificationEmail = value)
	@IsDefined({
		message: 'email is empty'
	})

	@IsEmail()
	public notificationEmail: string;

	//@property<UserItemModel>((o) => o.entity.roles, (o, value) => o.entity.roles = value)
	//public roles: string;

	@property<UserItemModel>(o => o.entity.password, (o, value) => o.entity.password = value)
	public password: string;

	public retypedPassword: string;

	public passwordChanged: boolean;

	@property<UserItemModel>(o => o.entity.avatar, (o, value) => o.entity.avatar = value)
	public avatar: Uint8Array;

	@property<any>(o => o.entity.dynamicProperties, (o, value) => o.entity.dynamicProperties = value)
	@Validate(UserDynamicPropertyValidation)
	public dynamicProperties: {};

	@property<UserItemModel>(o => o.entity.isRole, (o, value) => o.entity.isRole = value)
	public isRole: boolean;

	public roles: number[];

	public validatePasswords(operation: 'new' | 'update'): ValidationError[] | Promise<ValidationError[]> {
		const result: ValidationError[] = [];

		if (operation == 'new') {
			if (this.password == undefined || this.password.length == 0)
				result.push({ property: 'password', text: 'password is required' });
		}
		if (!this.passwordChanged && operation == 'update')
			return result;

		if (this.password != this.retypedPassword)
			result.push({ property: 'password', text: 'confirm password error' });

		return result;
	}
}



// WEBPACK FOOTER //
// ./src/app/general/users/form/user-form.data.ts